import { render, staticRenderFns } from "./kbNav.vue?vue&type=template&id=036877db&"
import script from "./kbNav.vue?vue&type=script&lang=js&"
export * from "./kbNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('036877db', component.options)
    } else {
      api.reload('036877db', component.options)
    }
    module.hot.accept("./kbNav.vue?vue&type=template&id=036877db&", function () {
      api.rerender('036877db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Settings/kbNav.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/kbNav.vue
// module id = Sdiw
// module chunks = 0